import React from "react";
import { FormattedMessage } from "react-intl";
import { Col } from "reactstrap";
import { Formatter } from "src/shared/formatters/Formatter";
import type { IntegrationWisepops } from "src/integrations/objects/IntegrationWisepops";
import { FeaturedLinkFormatter } from "src/shared/formatters/LinkFormatter";

export interface IIntegrationDetailWisepopsProps {
  integration: IntegrationWisepops;
}

export function IntegrationDetailWisepops({
  integration,
}: IIntegrationDetailWisepopsProps) {
  return (
    <>
      <Col sm={4} tag="dt">
        <FormattedMessage id="integrations.wisepops.api_key" />
      </Col>
      <Col sm={8} tag="dd">
        <Formatter value={integration.apiKey}>
          <code>{integration.apiKey}</code>
        </Formatter>
      </Col>

      <Col sm={4} tag="dt">
        <FormattedMessage id="integrations.wisepops.site_id" />
      </Col>
      <Col sm={8} tag="dd">
        <Formatter>{integration.webhookSiteId}</Formatter>
      </Col>

      <Col sm={4} tag="dt">
        <FormattedMessage id="integrations.webhook_url" />
      </Col>
      <Col sm={8} tag="dd">
        <FeaturedLinkFormatter showEllipsis isCopyable showTooltip>
          {integration.webhookUrl}
        </FeaturedLinkFormatter>
      </Col>
    </>
  );
}
